module.exports = __webpack_public_path__ + "img/cart.8e3736d5.svg";